import { Link } from "react-router-dom";
import { RoleBadge } from "@/components/RoleBadge";
import { UserAvatar } from "@/components/UserBits";
import { HonorBadge } from "@/components/HonorBadge";
import { Glitter } from "@/components/SupporterGlitter";

export const MemberCard = ({ m, i = 0, children }) => (
  <div data-testid={`community-member-${m.user_id}`} data-vip={m.supporter || undefined} style={{ animationDelay: `${Math.min(i, 20) * 30}ms` }}
    className={`fade-up rounded-2xl p-4 ${m.supporter ? "sp-post sp-glow" : "bg-white border border-pink-100 hover:border-rose-300"} flex flex-col items-center text-center gap-2 hover:-translate-y-0.5 transition-[transform,border-color]`}>
    {m.supporter && <Glitter size="sm" />}
    <Link to={`/u/${m.user_id}`} className="flex flex-col items-center gap-2 max-w-full" data-testid={`community-member-link-${m.user_id}`}>
      <UserAvatar userId={m.user_id} name={m.name} picture={m.picture} size="w-14 h-14" text="text-xl" />
      <span className="font-semibold text-sm max-w-full flex items-center justify-center gap-x-1 gap-y-0.5 flex-wrap"><span className="truncate max-w-full">{m.name}</span> <RoleBadge creator={m.role === "admin"} moderator={m.role === "moderator"} supporter={m.supporter} chip /><HonorBadge userId={m.user_id} /></span>
      <span className="text-[11px] text-slate-400">seit {new Date(m.created_at).toLocaleDateString("de-DE", { month: "short", year: "numeric" })}</span>
    </Link>
    {children}
  </div>
);

export const MemberGrid = ({ list, empty, testId = "community-list", render }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid={testId}>
    {list.length === 0 && <p className="col-span-full text-center text-slate-400 py-10" data-testid={`${testId}-empty`}>{empty}</p>}
    {list.map((m, i) => (render ? render(m, i) : <MemberCard key={m.user_id} m={m} i={i} />))}
  </div>
);
